module.exports = __webpack_public_path__ + "img/call_service.6cbc40f5.png";